import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarpentry = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 500 500",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M134.2 462.7C133.4 462.7 132.7 462 132.7 461.2V409.1C132.7 408.3 133.4 407.6 134.2 407.6C135 407.6 135.7 408.3 135.7 409.1V461.2C135.7 462 135 462.7 134.2 462.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.2 462.7C133.4 462.7 132.7 462 132.7 461.2V409.1C132.7 408.3 133.4 407.6 134.2 407.6C135 407.6 135.7 408.3 135.7 409.1V461.2C135.7 462 135 462.7 134.2 462.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.2 462.7C133.9 462.7 133.7 462.6 133.4 462.5L127.8 459.2C127.3 458.9 127.1 458.4 127.1 457.9V405.9C127.1 405.1 127.8 404.4 128.6 404.4C129.4 404.4 130.1 405.1 130.1 405.9V457L134.2 459.4L138.3 457V405.9C138.3 405.1 139 404.4 139.8 404.4C140.6 404.4 141.3 405.1 141.3 405.9V457.9C141.3 458.4 141 458.9 140.6 459.2L135 462.5C134.7 462.6 134.5 462.7 134.2 462.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.2 462.7C133.9 462.7 133.7 462.6 133.4 462.5L127.8 459.2C127.3 458.9 127.1 458.4 127.1 457.9V405.9C127.1 405.1 127.8 404.4 128.6 404.4C129.4 404.4 130.1 405.1 130.1 405.9V457L134.2 459.4L138.3 457V405.9C138.3 405.1 139 404.4 139.8 404.4C140.6 404.4 141.3 405.1 141.3 405.9V457.9C141.3 458.4 141 458.9 140.6 459.2L135 462.5C134.7 462.6 134.5 462.7 134.2 462.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.2 441.5C170.4 441.5 169.7 440.8 169.7 440V388.1C169.7 387.3 170.4 386.6 171.2 386.6C172 386.6 172.7 387.3 172.7 388.1V440C172.7 440.8 172 441.5 171.2 441.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.2 441.5C170.4 441.5 169.7 440.8 169.7 440V388.1C169.7 387.3 170.4 386.6 171.2 386.6C172 386.6 172.7 387.3 172.7 388.1V440C172.7 440.8 172 441.5 171.2 441.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.2 441.5C170.9 441.5 170.7 441.4 170.4 441.3L164.8 438C164.3 437.7 164.1 437.2 164.1 436.7V391.3C164.1 390.5 164.8 389.8 165.6 389.8C166.4 389.8 167.1 390.5 167.1 391.3V435.8L171.2 438.2L175.3 435.8V384.8C175.3 384 176 383.3 176.8 383.3C177.6 383.3 178.3 384 178.3 384.8V436.7C178.3 437.2 178 437.7 177.6 438L172 441.3C171.7 441.4 171.5 441.5 171.2 441.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.2 441.5C170.9 441.5 170.7 441.4 170.4 441.3L164.8 438C164.3 437.7 164.1 437.2 164.1 436.7V391.3C164.1 390.5 164.8 389.8 165.6 389.8C166.4 389.8 167.1 390.5 167.1 391.3V435.8L171.2 438.2L175.3 435.8V384.8C175.3 384 176 383.3 176.8 383.3C177.6 383.3 178.3 384 178.3 384.8V436.7C178.3 437.2 178 437.7 177.6 438L172 441.3C171.7 441.4 171.5 441.5 171.2 441.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.7998 439.8C92.9998 439.8 92.2998 439.1 92.2998 438.3V385.9C92.2998 385.1 92.9998 384.4 93.7998 384.4C94.5998 384.4 95.2998 385.1 95.2998 385.9V438.3C95.2998 439.1 94.5998 439.8 93.7998 439.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.7998 439.8C92.9998 439.8 92.2998 439.1 92.2998 438.3V385.9C92.2998 385.1 92.9998 384.4 93.7998 384.4C94.5998 384.4 95.2998 385.1 95.2998 385.9V438.3C95.2998 439.1 94.5998 439.8 93.7998 439.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.8002 439.8C93.5002 439.8 93.3002 439.7 93.0002 439.6L87.4002 436.3C86.9002 436 86.7002 435.5 86.7002 435V382.7C86.7002 381.9 87.4002 381.2 88.2002 381.2C89.0002 381.2 89.7002 381.9 89.7002 382.7V434.1L93.8002 436.5L97.9002 434.1V389.1C97.9002 388.3 98.6002 387.6 99.4002 387.6C100.2 387.6 100.9 388.3 100.9 389.1V435C100.9 435.5 100.6 436 100.2 436.3L94.6002 439.6C94.3002 439.7 94.1002 439.8 93.8002 439.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.8002 439.8C93.5002 439.8 93.3002 439.7 93.0002 439.6L87.4002 436.3C86.9002 436 86.7002 435.5 86.7002 435V382.7C86.7002 381.9 87.4002 381.2 88.2002 381.2C89.0002 381.2 89.7002 381.9 89.7002 382.7V434.1L93.8002 436.5L97.9002 434.1V389.1C97.9002 388.3 98.6002 387.6 99.4002 387.6C100.2 387.6 100.9 388.3 100.9 389.1V435C100.9 435.5 100.6 436 100.2 436.3L94.6002 439.6C94.3002 439.7 94.1002 439.8 93.8002 439.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.2 410.6C133.9 410.6 133.7 410.5 133.4 410.4L79.1004 379C78.6004 378.7 78.4004 378.2 78.4004 377.7V369.4C78.4004 368.6 79.1004 367.9 79.9004 367.9C80.7004 367.9 81.4004 368.6 81.4004 369.4V376.8L134.2 407.3L184.2 378.8V371.4C184.2 370.6 184.9 369.9 185.7 369.9C186.5 369.9 187.2 370.6 187.2 371.4V379.7C187.2 380.2 186.9 380.7 186.4 381L134.9 410.4C134.7 410.5 134.5 410.6 134.2 410.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.2 410.6C133.9 410.6 133.7 410.5 133.4 410.4L79.1004 379C78.6004 378.7 78.4004 378.2 78.4004 377.7V369.4C78.4004 368.6 79.1004 367.9 79.9004 367.9C80.7004 367.9 81.4004 368.6 81.4004 369.4V376.8L134.2 407.3L184.2 378.8V371.4C184.2 370.6 184.9 369.9 185.7 369.9C186.5 369.9 187.2 370.6 187.2 371.4V379.7C187.2 380.2 186.9 380.7 186.4 381L134.9 410.4C134.7 410.5 134.5 410.6 134.2 410.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.2 410.8C133.4 410.8 132.7 410.1 132.7 409.3V401C132.7 400.2 133.4 399.5 134.2 399.5C135 399.5 135.7 400.2 135.7 401V409.3C135.7 410.1 135 410.8 134.2 410.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.2 410.8C133.4 410.8 132.7 410.1 132.7 409.3V401C132.7 400.2 133.4 399.5 134.2 399.5C135 399.5 135.7 400.2 135.7 401V409.3C135.7 410.1 135 410.8 134.2 410.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.5 375C85.7 375 85 374.3 85 373.5V289.9C85 289.1 85.7 288.4 86.5 288.4C87.3 288.4 88 289.1 88 289.9V373.5C88 374.3 87.3 375 86.5 375Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.5 375C85.7 375 85 374.3 85 373.5V289.9C85 289.1 85.7 288.4 86.5 288.4C87.3 288.4 88 289.1 88 289.9V373.5C88 374.3 87.3 375 86.5 375Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.2 402.3C133.9 402.3 133.7 402.2 133.5 402.1L85.7997 374.8C85.0997 374.4 84.7997 373.5 85.1997 372.8C85.5997 372.1 86.4997 371.8 87.1997 372.2L134.2 399.1L182.7 371.4L137.2 345.4C136.5 345 136.2 344.1 136.6 343.4C137 342.7 137.9 342.4 138.6 342.8L186.4 370.1C186.9 370.4 187.2 370.9 187.2 371.4C187.2 371.9 186.9 372.4 186.4 372.7L134.9 402.1C134.7 402.2 134.5 402.3 134.2 402.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.2 402.3C133.9 402.3 133.7 402.2 133.5 402.1L85.7997 374.8C85.0997 374.4 84.7997 373.5 85.1997 372.8C85.5997 372.1 86.4997 371.8 87.1997 372.2L134.2 399.1L182.7 371.4L137.2 345.4C136.5 345 136.2 344.1 136.6 343.4C137 342.7 137.9 342.4 138.6 342.8L186.4 370.1C186.9 370.4 187.2 370.9 187.2 371.4C187.2 371.9 186.9 372.4 186.4 372.7L134.9 402.1C134.7 402.2 134.5 402.3 134.2 402.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.5 375C86 375 85.5 374.7 85.2 374.2C84.8 373.5 85 372.6 85.8 372.2L136.4 343.2V260.4C136.4 259.6 137.1 258.9 137.9 258.9C138.7 258.9 139.4 259.6 139.4 260.4V344.1C139.4 344.6 139.1 345.1 138.6 345.4L87.2 374.8C87 374.9 86.8 375 86.5 375Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.5 375C86 375 85.5 374.7 85.2 374.2C84.8 373.5 85 372.6 85.8 372.2L136.4 343.2V260.4C136.4 259.6 137.1 258.9 137.9 258.9C138.7 258.9 139.4 259.6 139.4 260.4V344.1C139.4 344.6 139.1 345.1 138.6 345.4L87.2 374.8C87 374.9 86.8 375 86.5 375Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.9004 371.1C79.1004 371.1 78.4004 370.4 78.4004 369.6V286C78.4004 285.2 79.1004 284.5 79.9004 284.5C80.7004 284.5 81.4004 285.2 81.4004 286V369.6C81.4004 370.4 80.7004 371.1 79.9004 371.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.9004 371.1C79.1004 371.1 78.4004 370.4 78.4004 369.6V286C78.4004 285.2 79.1004 284.5 79.9004 284.5C80.7004 284.5 81.4004 285.2 81.4004 286V369.6C81.4004 370.4 80.7004 371.1 79.9004 371.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.5004 291.4C86.2004 291.4 86.0004 291.3 85.7004 291.2L79.1004 287.3C78.6004 287 78.4004 286.5 78.4004 286C78.4004 285.5 78.7004 285 79.2004 284.7L130.7 255.2C131.2 254.9 131.8 254.9 132.2 255.2L138.7 259.1C139.2 259.4 139.4 259.9 139.4 260.4C139.4 260.9 139.1 261.4 138.6 261.7L87.2004 291.2C87.0004 291.3 86.8004 291.4 86.5004 291.4ZM82.9004 286L86.5004 288.1L134.9 260.3L131.3 258.2L82.9004 286Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.5004 291.4C86.2004 291.4 86.0004 291.3 85.7004 291.2L79.1004 287.3C78.6004 287 78.4004 286.5 78.4004 286C78.4004 285.5 78.7004 285 79.2004 284.7L130.7 255.2C131.2 254.9 131.8 254.9 132.2 255.2L138.7 259.1C139.2 259.4 139.4 259.9 139.4 260.4C139.4 260.9 139.1 261.4 138.6 261.7L87.2004 291.2C87.0004 291.3 86.8004 291.4 86.5004 291.4ZM82.9004 286L86.5004 288.1L134.9 260.3L131.3 258.2L82.9004 286Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M426.8 347.6C426 347.6 425.3 346.9 425.3 346.1V293.8C425.3 293 426 292.3 426.8 292.3C427.6 292.3 428.3 293 428.3 293.8V346.1C428.3 346.9 427.6 347.6 426.8 347.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M426.8 347.6C426 347.6 425.3 346.9 425.3 346.1V293.8C425.3 293 426 292.3 426.8 292.3C427.6 292.3 428.3 293 428.3 293.8V346.1C428.3 346.9 427.6 347.6 426.8 347.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M426.8 347.6C426.5 347.6 426.3 347.5 426.1 347.4L420.5 344.2C420 343.9 419.7 343.4 419.7 342.9V297C419.7 296.2 420.4 295.5 421.2 295.5C422 295.5 422.7 296.2 422.7 297V342L426.8 344.3L430.9 342V290.5C430.9 289.7 431.6 289 432.4 289C433.2 289 433.9 289.7 433.9 290.5V342.9C433.9 343.4 433.6 343.9 433.1 344.2L427.5 347.4C427.3 347.5 427.1 347.6 426.8 347.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M426.8 347.6C426.5 347.6 426.3 347.5 426.1 347.4L420.5 344.2C420 343.9 419.7 343.4 419.7 342.9V297C419.7 296.2 420.4 295.5 421.2 295.5C422 295.5 422.7 296.2 422.7 297V342L426.8 344.3L430.9 342V290.5C430.9 289.7 431.6 289 432.4 289C433.2 289 433.9 289.7 433.9 290.5V342.9C433.9 343.4 433.6 343.9 433.1 344.2L427.5 347.4C427.3 347.5 427.1 347.6 426.8 347.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M414.8 302C414.3 302 413.8 301.7 413.5 301.2C413.1 300.5 413.3 299.6 414 299.2L439 284.7V277.3C439 276.5 439.7 275.8 440.5 275.8C441.3 275.8 442 276.5 442 277.3V285.6C442 286.1 441.7 286.6 441.2 286.9L415.4 301.8C415.3 301.9 415.1 302 414.8 302Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M414.8 302C414.3 302 413.8 301.7 413.5 301.2C413.1 300.5 413.3 299.6 414 299.2L439 284.7V277.3C439 276.5 439.7 275.8 440.5 275.8C441.3 275.8 442 276.5 442 277.3V285.6C442 286.1 441.7 286.6 441.2 286.9L415.4 301.8C415.3 301.9 415.1 302 414.8 302Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M434.1 282.9C433.3 282.9 432.6 282.2 432.6 281.4V197.7C432.6 196.9 433.3 196.2 434.1 196.2C434.9 196.2 435.6 196.9 435.6 197.7V281.4C435.6 282.2 434.9 282.9 434.1 282.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M434.1 282.9C433.3 282.9 432.6 282.2 432.6 281.4V197.7C432.6 196.9 433.3 196.2 434.1 196.2C434.9 196.2 435.6 196.9 435.6 197.7V281.4C435.6 282.2 434.9 282.9 434.1 282.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M412.4 295.3C411.9 295.3 411.4 295 411.1 294.5C410.7 293.8 410.9 292.9 411.7 292.5L433.4 280.1C434.1 279.7 435 279.9 435.4 280.7C435.8 281.5 435.6 282.3 434.8 282.7L413.1 295.1C412.9 295.2 412.7 295.3 412.4 295.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M412.4 295.3C411.9 295.3 411.4 295 411.1 294.5C410.7 293.8 410.9 292.9 411.7 292.5L433.4 280.1C434.1 279.7 435 279.9 435.4 280.7C435.8 281.5 435.6 282.3 434.8 282.7L413.1 295.1C412.9 295.2 412.7 295.3 412.4 295.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M372 259.5C371.5 259.5 371 259.2 370.7 258.7C370.3 258 370.5 257.1 371.3 256.7L381.9 250.6C382.6 250.2 383.5 250.4 383.9 251.2C384.3 251.9 384.1 252.8 383.3 253.2L372.7 259.3C372.5 259.4 372.3 259.5 372 259.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M372 259.5C371.5 259.5 371 259.2 370.7 258.7C370.3 258 370.5 257.1 371.3 256.7L381.9 250.6C382.6 250.2 383.5 250.4 383.9 251.2C384.3 251.9 384.1 252.8 383.3 253.2L372.7 259.3C372.5 259.4 372.3 259.5 372 259.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M434.1 282.9C433.8 282.9 433.6 282.8 433.4 282.7L381.9 253.2C381.4 252.9 381.1 252.4 381.1 251.9V168.3C381.1 167.5 381.8 166.8 382.6 166.8C383.4 166.8 384.1 167.5 384.1 168.3V251L434.8 280.1C435.5 280.5 435.8 281.4 435.4 282.1C435.1 282.6 434.6 282.9 434.1 282.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M434.1 282.9C433.8 282.9 433.6 282.8 433.4 282.7L381.9 253.2C381.4 252.9 381.1 252.4 381.1 251.9V168.3C381.1 167.5 381.8 166.8 382.6 166.8C383.4 166.8 384.1 167.5 384.1 168.3V251L434.8 280.1C435.5 280.5 435.8 281.4 435.4 282.1C435.1 282.6 434.6 282.9 434.1 282.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M440.6 279C439.8 279 439.1 278.3 439.1 277.5V193.9C439.1 193.1 439.8 192.4 440.6 192.4C441.4 192.4 442.1 193.1 442.1 193.9V277.5C442.1 278.3 441.4 279 440.6 279Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M440.6 279C439.8 279 439.1 278.3 439.1 277.5V193.9C439.1 193.1 439.8 192.4 440.6 192.4C441.4 192.4 442.1 193.1 442.1 193.9V277.5C442.1 278.3 441.4 279 440.6 279Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M434.1 199.2C433.8 199.2 433.6 199.1 433.4 199L381.9 169.6C381.4 169.3 381.1 168.8 381.1 168.3C381.1 167.8 381.4 167.3 381.8 167L388.3 163.1C388.8 162.8 389.3 162.8 389.8 163.1L441.3 192.6C441.8 192.9 442.1 193.4 442.1 193.9C442.1 194.4 441.8 194.9 441.4 195.2L434.9 199C434.6 199.1 434.4 199.2 434.1 199.2ZM385.6 168.3L434.1 196L437.6 193.9L389.1 166.1L385.6 168.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M434.1 199.2C433.8 199.2 433.6 199.1 433.4 199L381.9 169.6C381.4 169.3 381.1 168.8 381.1 168.3C381.1 167.8 381.4 167.3 381.8 167L388.3 163.1C388.8 162.8 389.3 162.8 389.8 163.1L441.3 192.6C441.8 192.9 442.1 193.4 442.1 193.9C442.1 194.4 441.8 194.9 441.4 195.2L434.9 199C434.6 199.1 434.4 199.2 434.1 199.2ZM385.6 168.3L434.1 196L437.6 193.9L389.1 166.1L385.6 168.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M294.2 483C293.4 483 292.7 482.3 292.7 481.5V384.7C292.7 383.9 293.4 383.2 294.2 383.2C295 383.2 295.7 383.9 295.7 384.7V481.5C295.7 482.3 295 483 294.2 483Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M294.2 483C293.4 483 292.7 482.3 292.7 481.5V384.7C292.7 383.9 293.4 383.2 294.2 383.2C295 383.2 295.7 383.9 295.7 384.7V481.5C295.7 482.3 295 483 294.2 483Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M294.2 483C293.9 483 293.7 482.9 293.4 482.8L284.4 477.6C283.9 477.3 283.6 476.8 283.6 476.3V384.5C283.6 383.7 284.3 383 285.1 383C285.9 383 286.6 383.7 286.6 384.5V475.4L294.1 479.7L301.5 475.4V384.5C301.5 383.7 302.2 383 303 383C303.8 383 304.5 383.7 304.5 384.5V476.3C304.5 476.8 304.2 477.3 303.8 477.6L294.9 482.8C294.7 482.9 294.5 483 294.2 483Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M294.2 483C293.9 483 293.7 482.9 293.4 482.8L284.4 477.6C283.9 477.3 283.6 476.8 283.6 476.3V384.5C283.6 383.7 284.3 383 285.1 383C285.9 383 286.6 383.7 286.6 384.5V475.4L294.1 479.7L301.5 475.4V384.5C301.5 383.7 302.2 383 303 383C303.8 383 304.5 383.7 304.5 384.5V476.3C304.5 476.8 304.2 477.3 303.8 477.6L294.9 482.8C294.7 482.9 294.5 483 294.2 483Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.2 433.4C202.4 433.4 201.7 432.7 201.7 431.9V362.4C201.7 361.6 202.4 360.9 203.2 360.9C204 360.9 204.7 361.6 204.7 362.4V431.9C204.7 432.7 204 433.4 203.2 433.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.2 433.4C202.4 433.4 201.7 432.7 201.7 431.9V362.4C201.7 361.6 202.4 360.9 203.2 360.9C204 360.9 204.7 361.6 204.7 362.4V431.9C204.7 432.7 204 433.4 203.2 433.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.2 433.4C202.9 433.4 202.7 433.3 202.4 433.2L193.5 428C193 427.7 192.8 427.2 192.8 426.7V356.2C192.8 355.4 193.5 354.7 194.3 354.7C195.1 354.7 195.8 355.4 195.8 356.2V425.8L203.2 430.1L210.6 425.8V367.3C210.6 366.5 211.3 365.8 212.1 365.8C212.9 365.8 213.6 366.5 213.6 367.3V426.7C213.6 427.2 213.3 427.7 212.9 428L204 433.2C203.7 433.3 203.5 433.4 203.2 433.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.2 433.4C202.9 433.4 202.7 433.3 202.4 433.2L193.5 428C193 427.7 192.8 427.2 192.8 426.7V356.2C192.8 355.4 193.5 354.7 194.3 354.7C195.1 354.7 195.8 355.4 195.8 356.2V425.8L203.2 430.1L210.6 425.8V367.3C210.6 366.5 211.3 365.8 212.1 365.8C212.9 365.8 213.6 366.5 213.6 367.3V426.7C213.6 427.2 213.3 427.7 212.9 428L204 433.2C203.7 433.3 203.5 433.4 203.2 433.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M385.8 433.4C385 433.4 384.3 432.7 384.3 431.9V361.9C384.3 361.1 385 360.4 385.8 360.4C386.6 360.4 387.3 361.1 387.3 361.9V431.9C387.3 432.7 386.6 433.4 385.8 433.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M385.8 433.4C385 433.4 384.3 432.7 384.3 431.9V361.9C384.3 361.1 385 360.4 385.8 360.4C386.6 360.4 387.3 361.1 387.3 361.9V431.9C387.3 432.7 386.6 433.4 385.8 433.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M385.8 433.4C385.5 433.4 385.3 433.3 385 433.2L376 428C375.5 427.7 375.2 427.2 375.2 426.7V367C375.2 366.2 375.9 365.5 376.7 365.5C377.5 365.5 378.2 366.2 378.2 367V425.8L385.7 430.1L393.1 425.8V355.6C393.1 354.8 393.8 354.1 394.6 354.1C395.4 354.1 396.1 354.8 396.1 355.6V426.7C396.1 427.2 395.8 427.7 395.4 428L386.5 433.2C386.3 433.3 386.1 433.4 385.8 433.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M385.8 433.4C385.5 433.4 385.3 433.3 385 433.2L376 428C375.5 427.7 375.2 427.2 375.2 426.7V367C375.2 366.2 375.9 365.5 376.7 365.5C377.5 365.5 378.2 366.2 378.2 367V425.8L385.7 430.1L393.1 425.8V355.6C393.1 354.8 393.8 354.1 394.6 354.1C395.4 354.1 396.1 354.8 396.1 355.6V426.7C396.1 427.2 395.8 427.7 395.4 428L386.5 433.2C386.3 433.3 386.1 433.4 385.8 433.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M294.2 386.1C261.4 386.1 230.6 379.1 207.4 366.4C183.9 353.5 171 336.4 171 318V309.2C171 308.4 171.7 307.7 172.5 307.7C173.3 307.7 174 308.4 174 309.2V318C174 353.9 227.9 383.1 294.2 383.1C360.5 383.1 414.4 353.9 414.4 318V309.5C414.4 308.7 415.1 308 415.9 308C416.7 308 417.4 308.7 417.4 309.5V318C417.4 336.4 404.5 353.6 381 366.4C357.8 379.1 327 386.1 294.2 386.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M294.2 386.1C261.4 386.1 230.6 379.1 207.4 366.4C183.9 353.5 171 336.4 171 318V309.2C171 308.4 171.7 307.7 172.5 307.7C173.3 307.7 174 308.4 174 309.2V318C174 353.9 227.9 383.1 294.2 383.1C360.5 383.1 414.4 353.9 414.4 318V309.5C414.4 308.7 415.1 308 415.9 308C416.7 308 417.4 308.7 417.4 309.5V318C417.4 336.4 404.5 353.6 381 366.4C357.8 379.1 327 386.1 294.2 386.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M294.1 377.3C261.3 377.3 230.5 370.3 207.3 357.6C183.8 344.7 170.9 327.6 170.9 309.2C170.9 271.6 226.2 241.1 294.1 241.1C326.9 241.1 357.7 248.1 380.9 260.8C404.4 273.7 417.3 290.8 417.3 309.2C417.3 327.6 404.4 344.8 380.9 357.6C357.7 370.3 326.9 377.3 294.1 377.3ZM294.1 244.1C227.8 244.1 173.9 273.3 173.9 309.2C173.9 345.1 227.8 374.3 294.1 374.3C360.4 374.3 414.3 345.1 414.3 309.2C414.3 273.3 360.4 244.1 294.1 244.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M294.1 377.3C261.3 377.3 230.5 370.3 207.3 357.6C183.8 344.7 170.9 327.6 170.9 309.2C170.9 271.6 226.2 241.1 294.1 241.1C326.9 241.1 357.7 248.1 380.9 260.8C404.4 273.7 417.3 290.8 417.3 309.2C417.3 327.6 404.4 344.8 380.9 357.6C357.7 370.3 326.9 377.3 294.1 377.3ZM294.1 244.1C227.8 244.1 173.9 273.3 173.9 309.2C173.9 345.1 227.8 374.3 294.1 374.3C360.4 374.3 414.3 345.1 414.3 309.2C414.3 273.3 360.4 244.1 294.1 244.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M134.6 408.9L79.9004 377.3V286L86.5004 289.7V373.5L134.2 401L134.6 408.9Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M134.6 408.9L79.9004 377.3V286L86.5004 289.7V373.5L134.2 401L134.6 408.9Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M93.8002 438.1L88.2002 435.1V384.3L93.8002 387.3V438.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M93.8002 438.1L88.2002 435.1V384.3L93.8002 387.3V438.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M134.2 461.2L128.6 458.2V407.4L134.2 410.4V461.2Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M134.2 461.2L128.6 458.2V407.4L134.2 410.4V461.2Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M202.9 431.5L194.3 426.9V357.4L202.9 362V431.5Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M202.9 431.5L194.3 426.9V357.4L202.9 362V431.5Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M293.8 481L285.2 476.4V384.7L293.8 385.3V481Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M293.8 481L285.2 476.4V384.7L293.8 385.3V481Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M385.4 431.9L376.8 427V367.9L385.4 362.9V431.9Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M385.4 431.9L376.8 427V367.9L385.4 362.9V431.9Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M385.8 432L394.4 427.4V357.9L385.8 362.5V432Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M385.8 432L394.4 427.4V357.9L385.8 362.5V432Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M294.8 481.5L303.4 476.8V385.2L294.8 385.7V481.5Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M294.8 481.5L303.4 476.8V385.2L294.8 385.7V481.5Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M203.2 432.3L211.8 427.5V368.4L203.2 363.4V432.3Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M203.2 432.3L211.8 427.5V368.4L203.2 363.4V432.3Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M171.2 439.7L165.6 436.7V391.9L171.2 388.9V439.7Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M171.2 439.7L165.6 436.7V391.9L171.2 388.9V439.7Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M176.8 435.9L171.2 439.1V388L176.8 385.1V435.9Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M176.8 435.9L171.2 439.1V388L176.8 385.1V435.9Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M138.9 457.3L133.3 460.6V409.5L138.9 406.5V457.3Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M138.9 457.3L133.3 460.6V409.5L138.9 406.5V457.3Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M99.3998 434.2L93.7998 437.5V386.4L99.3998 389.1V434.2Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M99.3998 434.2L93.7998 437.5V386.4L99.3998 389.1V434.2Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M137.9 344.1L86.5 373.5V289.9L137.9 260.8V344.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M137.9 344.1L86.5 373.5V289.9L137.9 260.8V344.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M185.6 380.2L134.1 409.6V400.4L185.6 371.3V380.2Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M185.6 380.2L134.1 409.6V400.4L185.6 371.3V380.2Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M138.3 260.1L86.8004 289.5L79.9004 285.6L131.4 256.5L138.3 260.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M138.3 260.1L86.8004 289.5L79.9004 285.6L131.4 256.5L138.3 260.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M382.9 168.1L434.4 197.6L441.3 193.7L389.8 164.6L382.9 168.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M382.9 168.1L434.4 197.6L441.3 193.7L389.8 164.6L382.9 168.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M185.1 372L133.6 401.4L87.4004 373.5L138.8 344.4L185.1 372Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M185.1 372L133.6 401.4L87.4004 373.5L138.8 344.4L185.1 372Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M440.6 193.5V284.8L414.3 300C413.8 297.9 413 295.8 412.1 293.7V293.6L415.4 291.7L434 281V197.2L440.6 193.5Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M440.6 193.5V284.8L414.3 300C413.8 297.9 413 295.8 412.1 293.7V293.6L415.4 291.7L434 281V197.2L440.6 193.5Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M426.8 345.6L432.4 342.6V291.8L426.8 294.8V345.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M426.8 345.6L432.4 342.6V291.8L426.8 294.8V345.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M421.2 341.8L426.8 345V293.9L421.2 296.6V341.8Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M421.2 341.8L426.8 345V293.9L421.2 296.6V341.8Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M382.6 251.6L434.1 281V197.4L382.6 168.3V251.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M382.6 251.6L434.1 281V197.4L382.6 168.3V251.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M433.2 281L415.5 291.7L412.2 293.7V293.6C406 279.4 391.5 267 371.6 257.9L381.7 251.9L433.2 281Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M433.2 281L415.5 291.7L412.2 293.7V293.6C406 279.4 391.5 267 371.6 257.9L381.7 251.9L433.2 281Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M173.2 308.7C173.2 345.5 227.7 375.3 294.9 375.3C362.1 375.3 416.6 345.5 416.6 308.7V318.7C416.6 355.5 362.1 385.3 294.9 385.3C227.7 385.3 173.2 355.5 173.2 318.7V308.7Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M173.2 308.7C173.2 345.5 227.7 375.3 294.9 375.3C362.1 375.3 416.6 345.5 416.6 308.7V318.7C416.6 355.5 362.1 385.3 294.9 385.3C227.7 385.3 173.2 355.5 173.2 318.7V308.7Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M293.8 242.6C361 242.6 415.5 272.4 415.5 309.2C415.5 346 361 375.8 293.8 375.8C226.6 375.8 172.1 346 172.1 309.2C172.1 272.4 226.6 242.6 293.8 242.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M293.8 242.6C361 242.6 415.5 272.4 415.5 309.2C415.5 346 361 375.8 293.8 375.8C226.6 375.8 172.1 346 172.1 309.2C172.1 272.4 226.6 242.6 293.8 242.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 111.1C110.2 111.1 109.7 110.8 109.4 110.3C109 109.6 109.2 108.7 109.9 108.3L194 59.7L156.2 38L74.9002 84.9C74.2002 85.3 73.3002 85.1 72.9002 84.4C72.5002 83.7 72.7002 82.8 73.4002 82.4L155.4 35.1C155.9 34.8 156.4 34.8 156.9 35.1L197.8 58.5C198.3 58.8 198.6 59.3 198.6 59.8C198.6 60.3 198.3 60.8 197.8 61.1L111.4 111C111.2 111 111 111.1 110.7 111.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 111.1C110.2 111.1 109.7 110.8 109.4 110.3C109 109.6 109.2 108.7 109.9 108.3L194 59.7L156.2 38L74.9002 84.9C74.2002 85.3 73.3002 85.1 72.9002 84.4C72.5002 83.7 72.7002 82.8 73.4002 82.4L155.4 35.1C155.9 34.8 156.4 34.8 156.9 35.1L197.8 58.5C198.3 58.8 198.6 59.3 198.6 59.8C198.6 60.3 198.3 60.8 197.8 61.1L111.4 111C111.2 111 111 111.1 110.7 111.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 117.6C110.2 117.6 109.7 117.3 109.4 116.8C109 116.1 109.2 115.2 109.9 114.8L196.3 64.9C197 64.5 197.9 64.7 198.3 65.4C198.7 66.1 198.5 67 197.8 67.4L111.4 117.3C111.2 117.5 111 117.6 110.7 117.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 117.6C110.2 117.6 109.7 117.3 109.4 116.8C109 116.1 109.2 115.2 109.9 114.8L196.3 64.9C197 64.5 197.9 64.7 198.3 65.4C198.7 66.1 198.5 67 197.8 67.4L111.4 117.3C111.2 117.5 111 117.6 110.7 117.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 173.4C110.2 173.4 109.7 173.1 109.4 172.6C109 171.9 109.2 171 109.9 170.6L194 122L156.1 100.3L111.3 126.2C110.6 126.6 109.7 126.4 109.3 125.7C108.9 125 109.1 124.1 109.8 123.7L155.3 97.4C155.8 97.1 156.3 97.1 156.8 97.4L197.7 120.8C198.2 121.1 198.5 121.6 198.5 122.1C198.5 122.6 198.2 123.1 197.7 123.4L111.3 173.3C111.2 173.3 111 173.4 110.7 173.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 173.4C110.2 173.4 109.7 173.1 109.4 172.6C109 171.9 109.2 171 109.9 170.6L194 122L156.1 100.3L111.3 126.2C110.6 126.6 109.7 126.4 109.3 125.7C108.9 125 109.1 124.1 109.8 123.7L155.3 97.4C155.8 97.1 156.3 97.1 156.8 97.4L197.7 120.8C198.2 121.1 198.5 121.6 198.5 122.1C198.5 122.6 198.2 123.1 197.7 123.4L111.3 173.3C111.2 173.3 111 173.4 110.7 173.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 179.9C110.2 179.9 109.7 179.6 109.4 179.1C109 178.4 109.2 177.5 110 177.1L196.4 127.3C197.1 126.9 198 127.1 198.4 127.9C198.8 128.6 198.6 129.5 197.8 129.9L111.4 179.7C111.2 179.8 111 179.9 110.7 179.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 179.9C110.2 179.9 109.7 179.6 109.4 179.1C109 178.4 109.2 177.5 110 177.1L196.4 127.3C197.1 126.9 198 127.1 198.4 127.9C198.8 128.6 198.6 129.5 197.8 129.9L111.4 179.7C111.2 179.8 111 179.9 110.7 179.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 234.8C110.2 234.8 109.7 234.5 109.4 234C109 233.3 109.2 232.4 110 232L194.1 183.5L156.2 161.7L111.4 187.6C110.7 188 109.8 187.8 109.4 187.1C109 186.4 109.2 185.5 109.9 185.1L155.4 158.8C155.9 158.5 156.4 158.5 156.9 158.8L197.8 182.3C198.3 182.6 198.6 183.1 198.6 183.6C198.6 184.1 198.3 184.6 197.8 184.9L111.4 234.7C111.2 234.7 111 234.8 110.7 234.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 234.8C110.2 234.8 109.7 234.5 109.4 234C109 233.3 109.2 232.4 110 232L194.1 183.5L156.2 161.7L111.4 187.6C110.7 188 109.8 187.8 109.4 187.1C109 186.4 109.2 185.5 109.9 185.1L155.4 158.8C155.9 158.5 156.4 158.5 156.9 158.8L197.8 182.3C198.3 182.6 198.6 183.1 198.6 183.6C198.6 184.1 198.3 184.6 197.8 184.9L111.4 234.7C111.2 234.7 111 234.8 110.7 234.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 241.4C110.2 241.4 109.7 241.1 109.4 240.6C109 239.9 109.2 239 109.9 238.6L196.3 188.7C197 188.3 197.9 188.5 198.3 189.2C198.7 189.9 198.5 190.8 197.8 191.2L111.4 241.1C111.2 241.3 111 241.4 110.7 241.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 241.4C110.2 241.4 109.7 241.1 109.4 240.6C109 239.9 109.2 239 109.9 238.6L196.3 188.7C197 188.3 197.9 188.5 198.3 189.2C198.7 189.9 198.5 190.8 197.8 191.2L111.4 241.1C111.2 241.3 111 241.4 110.7 241.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.9 280.4C137.4 280.4 136.9 280.1 136.6 279.6C136.2 278.9 136.4 278 137.1 277.6L194 244.7L156.2 223L111.4 248.8C110.7 249.2 109.8 249 109.4 248.2C109 247.5 109.2 246.6 110 246.2L155.5 220C156 219.7 156.5 219.7 157 220L197.9 243.4C198.4 243.7 198.7 244.2 198.7 244.7C198.7 245.2 198.4 245.7 198 246L138.8 280.2C138.4 280.3 138.2 280.4 137.9 280.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.9 280.4C137.4 280.4 136.9 280.1 136.6 279.6C136.2 278.9 136.4 278 137.1 277.6L194 244.7L156.2 223L111.4 248.8C110.7 249.2 109.8 249 109.4 248.2C109 247.5 109.2 246.6 110 246.2L155.5 220C156 219.7 156.5 219.7 157 220L197.9 243.4C198.4 243.7 198.7 244.2 198.7 244.7C198.7 245.2 198.4 245.7 198 246L138.8 280.2C138.4 280.3 138.2 280.4 137.9 280.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.9 286.9C137.4 286.9 136.9 286.6 136.6 286.1C136.2 285.4 136.4 284.5 137.2 284.1L196.4 250C197.1 249.6 198 249.8 198.4 250.6C198.8 251.3 198.6 252.2 197.8 252.6L138.6 286.7C138.4 286.8 138.2 286.9 137.9 286.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.9 286.9C137.4 286.9 136.9 286.6 136.6 286.1C136.2 285.4 136.4 284.5 137.2 284.1L196.4 250C197.1 249.6 198 249.8 198.4 250.6C198.8 251.3 198.6 252.2 197.8 252.6L138.6 286.7C138.4 286.8 138.2 286.9 137.9 286.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105.2 273.2C104.4 273.2 103.7 272.5 103.7 271.7V107.8C103.7 107 104.4 106.3 105.2 106.3C106 106.3 106.7 107 106.7 107.8V271.7C106.7 272.5 106 273.2 105.2 273.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105.2 273.2C104.4 273.2 103.7 272.5 103.7 271.7V107.8C103.7 107 104.4 106.3 105.2 106.3C106 106.3 106.7 107 106.7 107.8V271.7C106.7 272.5 106 273.2 105.2 273.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.1004 298.9C79.8004 298.9 79.6004 298.8 79.4004 298.7L60.7004 288C60.2004 287.7 59.9004 287.2 59.9004 286.7V82.8C59.9004 82 60.6004 81.3 61.4004 81.3C62.2004 81.3 62.9004 82 62.9004 82.8V285.8L80.8004 296.1C81.5004 296.5 81.8004 297.4 81.4004 298.1C81.1004 298.6 80.6004 298.9 80.1004 298.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.1004 298.9C79.8004 298.9 79.6004 298.8 79.4004 298.7L60.7004 288C60.2004 287.7 59.9004 287.2 59.9004 286.7V82.8C59.9004 82 60.6004 81.3 61.4004 81.3C62.2004 81.3 62.9004 82 62.9004 82.8V285.8L80.8004 296.1C81.5004 296.5 81.8004 297.4 81.4004 298.1C81.1004 298.6 80.6004 298.9 80.1004 298.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 270.1C109.9 270.1 109.2 269.4 109.2 268.6V104.5C109.2 103.7 109.9 103 110.7 103C111.5 103 112.2 103.7 112.2 104.5V268.6C112.2 269.4 111.5 270.1 110.7 270.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.7 270.1C109.9 270.1 109.2 269.4 109.2 268.6V104.5C109.2 103.7 109.9 103 110.7 103C111.5 103 112.2 103.7 112.2 104.5V268.6C112.2 269.4 111.5 270.1 110.7 270.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105.2 109.3C104.9 109.3 104.7 109.2 104.5 109.1L60.7004 84.1C60.2004 83.8 59.9004 83.3 59.9004 82.8C59.9004 82.3 60.2004 81.8 60.6004 81.5L66.1004 78.2C66.6004 77.9 67.1004 77.9 67.6004 78.2L111.4 103.2C111.9 103.5 112.2 104 112.2 104.5C112.2 105 111.9 105.5 111.5 105.8L106 109.1C105.7 109.2 105.5 109.3 105.2 109.3ZM64.4004 82.8L105.2 106.1L107.7 104.6L66.9004 81.2L64.4004 82.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105.2 109.3C104.9 109.3 104.7 109.2 104.5 109.1L60.7004 84.1C60.2004 83.8 59.9004 83.3 59.9004 82.8C59.9004 82.3 60.2004 81.8 60.6004 81.5L66.1004 78.2C66.6004 77.9 67.1004 77.9 67.6004 78.2L111.4 103.2C111.9 103.5 112.2 104 112.2 104.5C112.2 105 111.9 105.5 111.5 105.8L106 109.1C105.7 109.2 105.5 109.3 105.2 109.3ZM64.4004 82.8L105.2 106.1L107.7 104.6L66.9004 81.2L64.4004 82.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.1 260.5C196.3 260.5 195.6 259.8 195.6 259V55C195.6 54.2 196.3 53.5 197.1 53.5C197.9 53.5 198.6 54.2 198.6 55V259C198.6 259.8 197.9 260.5 197.1 260.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.1 260.5C196.3 260.5 195.6 259.8 195.6 259V55C195.6 54.2 196.3 53.5 197.1 53.5C197.9 53.5 198.6 54.2 198.6 55V259C198.6 259.8 197.9 260.5 197.1 260.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M153.3 39.4C152.5 39.4 151.8 38.7 151.8 37.9V30C151.8 29.2 152.5 28.5 153.3 28.5C154.1 28.5 154.8 29.2 154.8 30V37.9C154.8 38.7 154.1 39.4 153.3 39.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M153.3 39.4C152.5 39.4 151.8 38.7 151.8 37.9V30C151.8 29.2 152.5 28.5 153.3 28.5C154.1 28.5 154.8 29.2 154.8 30V37.9C154.8 38.7 154.1 39.4 153.3 39.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M153.3 101.7C152.5 101.7 151.8 101 151.8 100.2V91.5C151.8 90.7 152.5 90 153.3 90C154.1 90 154.8 90.7 154.8 91.5V100.2C154.8 101 154.1 101.7 153.3 101.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M153.3 101.7C152.5 101.7 151.8 101 151.8 100.2V91.5C151.8 90.7 152.5 90 153.3 90C154.1 90 154.8 90.7 154.8 91.5V100.2C154.8 101 154.1 101.7 153.3 101.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M153.3 163.2C152.5 163.2 151.8 162.5 151.8 161.7V153.8C151.8 153 152.5 152.3 153.3 152.3C154.1 152.3 154.8 153 154.8 153.8V161.7C154.8 162.5 154.1 163.2 153.3 163.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M153.3 163.2C152.5 163.2 151.8 162.5 151.8 161.7V153.8C151.8 153 152.5 152.3 153.3 152.3C154.1 152.3 154.8 153 154.8 153.8V161.7C154.8 162.5 154.1 163.2 153.3 163.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M153.3 224.4C152.5 224.4 151.8 223.7 151.8 222.9V215.2C151.8 214.4 152.5 213.7 153.3 213.7C154.1 213.7 154.8 214.4 154.8 215.2V222.9C154.8 223.7 154.1 224.4 153.3 224.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M153.3 224.4C152.5 224.4 151.8 223.7 151.8 222.9V215.2C151.8 214.4 152.5 213.7 153.3 213.7C154.1 213.7 154.8 214.4 154.8 215.2V222.9C154.8 223.7 154.1 224.4 153.3 224.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.1 260.5C196.8 260.5 196.6 260.4 196.3 260.3L189.6 256.4C188.9 256 188.6 255.1 189.1 254.3C189.5 253.6 190.4 253.3 191.2 253.8L197.9 257.7C198.6 258.1 198.9 259 198.4 259.8C198.1 260.2 197.6 260.5 197.1 260.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.1 260.5C196.8 260.5 196.6 260.4 196.3 260.3L189.6 256.4C188.9 256 188.6 255.1 189.1 254.3C189.5 253.6 190.4 253.3 191.2 253.8L197.9 257.7C198.6 258.1 198.9 259 198.4 259.8C198.1 260.2 197.6 260.5 197.1 260.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.1 260.5C196.6 260.5 196.1 260.2 195.8 259.8C195.4 259.1 195.6 258.2 196.3 257.7L201.1 254.8V51.7C201.1 50.9 201.8 50.2 202.6 50.2C203.4 50.2 204.1 50.9 204.1 51.7V255.7C204.1 256.2 203.8 256.7 203.4 257L197.9 260.3C197.6 260.4 197.4 260.5 197.1 260.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.1 260.5C196.6 260.5 196.1 260.2 195.8 259.8C195.4 259.1 195.6 258.2 196.3 257.7L201.1 254.8V51.7C201.1 50.9 201.8 50.2 202.6 50.2C203.4 50.2 204.1 50.9 204.1 51.7V255.7C204.1 256.2 203.8 256.7 203.4 257L197.9 260.3C197.6 260.4 197.4 260.5 197.1 260.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.1 56.5C196.8 56.5 196.6 56.4 196.4 56.3L152.6 31.3C152.1 31 151.8 30.5 151.8 30C151.8 29.5 152.1 29 152.5 28.7L158.1 25.4C158.6 25.1 159.1 25.1 159.6 25.4L203.3 50.4C203.8 50.7 204.1 51.2 204.1 51.7C204.1 52.2 203.8 52.7 203.4 53L197.9 56.3C197.6 56.4 197.4 56.5 197.1 56.5ZM156.3 30L197.1 53.3L199.7 51.8L159 28.5L156.3 30Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.1 56.5C196.8 56.5 196.6 56.4 196.4 56.3L152.6 31.3C152.1 31 151.8 30.5 151.8 30C151.8 29.5 152.1 29 152.5 28.7L158.1 25.4C158.6 25.1 159.1 25.1 159.6 25.4L203.3 50.4C203.8 50.7 204.1 51.2 204.1 51.7C204.1 52.2 203.8 52.7 203.4 53L197.9 56.3C197.6 56.4 197.4 56.5 197.1 56.5ZM156.3 30L197.1 53.3L199.7 51.8L159 28.5L156.3 30Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M105.1 107.5V271.8L80.6004 286V297.4L61.4004 286.5V82.8L105.1 107.5Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M105.1 107.5V271.8L80.6004 286V297.4L61.4004 286.5V82.8L105.1 107.5Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M197.1 54.7V59L156.2 36.1L153.3 37.8V30L197.1 54.7Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M197.1 54.7V59L156.2 36.1L153.3 37.8V30L197.1 54.7Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M197.1 66.8V121.4L156.2 98.5L153.3 100.1V91.5L197.1 66.8Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M197.1 66.8V121.4L156.2 98.5L153.3 100.1V91.5L197.1 66.8Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M153.3 153.8L197.1 129.2V182.9L156.2 160L153.3 161.7V153.8Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M153.3 153.8L197.1 129.2V182.9L156.2 160L153.3 161.7V153.8Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M153.3 215.4L197.1 190.7V244.3L156.2 221.3L153.3 222.9V215.4Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M153.3 215.4L197.1 190.7V244.3L156.2 221.3L153.3 222.9V215.4Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M190.8 254.9L197.1 251.3V258.5L190.8 254.9Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M190.8 254.9L197.1 251.3V258.5L190.8 254.9Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M153.1 99.7L110.7 123.9V117.3L153.1 93.1V99.7Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M153.1 99.7L110.7 123.9V117.3L153.1 93.1V99.7Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M153.1 161.9L110.7 186.1V179.5L153.1 155.3V161.9Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M153.1 161.9L110.7 186.1V179.5L153.1 155.3V161.9Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M153.1 221.8L110.7 246V239.4L153.1 215.2V221.8Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M153.1 221.8L110.7 246V239.4L153.1 215.2V221.8Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M196.6 60L111.4 109.6L110.9 104.3L74.7002 83.2L156.2 36.4L196.6 60Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M196.6 60L111.4 109.6L110.9 104.3L74.7002 83.2L156.2 36.4L196.6 60Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M196.6 122.3L111.4 171.8L110.9 166.5L110.7 166.4V124.8L156.2 98.7L196.6 122.3Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M196.6 122.3L111.4 171.8L110.9 166.5L110.7 166.4V124.8L156.2 98.7L196.6 122.3Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M196.6 183.1L111.4 232.6L110.9 227.4L110.7 227.3V185.6L156.2 159.5L196.6 183.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M196.6 183.1L111.4 232.6L110.9 227.4L110.7 227.3V185.6L156.2 159.5L196.6 183.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M138.3 278.9V260.4L131.5 256.5L110.7 268.6V247.5L156.2 221.4L196.6 245L138.3 278.9Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M138.3 278.9V260.4L131.5 256.5L110.7 268.6V247.5L156.2 221.4L196.6 245L138.3 278.9Z",
				fill: "white",
				fillOpacity: .3
			})]
		})
	]
});
export default SvgCarpentry;
